// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"BBHTML_fullscreen__694UO","fullwindow":"BBHTML_fullwindow__i4VMW"};